import { Grid } from "@mui/material";
import Field from "components/Field";
import { DeliveryMethodSetting } from "services/KnowfullyAdminClient";
import {
  DeliveryMethodSettingsDataType,
  DeliveryMethodId,
  DeliveryMethodSettingCodeConstants,
} from "types/common-types";
import { settingsToRender } from "./settingsToRender";
import BooleanSetting from "./SettingFields/BooleanSetting";
import IframeSetting from "./SettingFields/IframeSetting";
import PageContentSetting from "./SettingFields/PageContentSetting";
import StandardSetting from "./SettingFields/StandardSetting";
import VimeoSetting from "./SettingFields/VimeoSetting";

type SkuDeliveryMethodSettingFormProps = {
  settings: SkuDeliveryMethodSettingProps[];
  deliveryMethodId?: string;
};

export class SkuDeliveryMethodSettingProps {
  constructor(obj: DeliveryMethodSetting, value?: string) {
    this.id = obj.id!;
    this.dataTypeName = obj.dataTypeName!;
    this.name = obj.name!;
    this.codeConstant = obj.codeConstant!;
    this.overridable = obj.overridable!;
    this.sequence = obj.sequence!;
    this.fieldIndex = 0;
    this.value = value;
  }

  id: string;
  dataTypeName: string;
  name: string;
  codeConstant: string;
  value?: string;
  overridable: boolean;
  sequence: number;
  fieldIndex: number;
}

const getFieldComponent = (
  item: SkuDeliveryMethodSettingProps,
  deliveryMethodId?: string
): JSX.Element => {
  if (
    item.codeConstant === DeliveryMethodSettingCodeConstants.Id &&
    deliveryMethodId === DeliveryMethodId.Vimeo
  ) {
    return <VimeoSetting item={item} />;
  }

  if (
    item.codeConstant === DeliveryMethodSettingCodeConstants.PageContent &&
    deliveryMethodId === DeliveryMethodId.Page
  ) {
    return <PageContentSetting item={item} />;
  }

  switch (item.dataTypeName) {
    case DeliveryMethodSettingsDataType.Iframe:
      return <IframeSetting item={item} />;
    case DeliveryMethodSettingsDataType.Boolean:
      return <BooleanSetting item={item} />;
    default:
      return <StandardSetting item={item} />;
  }
};

const SkuDeliveryMethodSetting = ({
  settings,
  deliveryMethodId,
}: SkuDeliveryMethodSettingFormProps) => {

  return (
    <>
      {settingsToRender(settings).map((item) => (
        <Grid key={item.id} item xs={12}>
          <Field
            name={`settingValues[${item.fieldIndex}].setting.id`}
            component="input"
            initialValue={item.id}
            type="hidden"
          />
          <Field
            name={`settingValues[${item.fieldIndex}].setting.name`}
            component="input"
            initialValue={item.name}
            type="hidden"
          />
          {getFieldComponent(item, deliveryMethodId)}
        </Grid>
      ))}
    </>
  );
};

export default SkuDeliveryMethodSetting;
